export default __webpack_public_path__ + "static/media/confirmed-home.406dde75.svg";